import { combineReducers, createStore } from 'redux';
import { reducers } from 'sonata-react-components';

const rootReducer = combineReducers(reducers);

const contextSystemStore = createStore(rootReducer);

export type ContextSystemRootState = ReturnType<typeof rootReducer>;
export type ContextSystemDispatch = typeof contextSystemStore.dispatch;
export default contextSystemStore;
